var $e73bf42412feb220$exports = {};
const { algoliasearch: $e73bf42412feb220$var$algoliasearch, instantsearch: $e73bf42412feb220$var$instantsearch } = window;
const $e73bf42412feb220$var$searchClient = $e73bf42412feb220$var$algoliasearch('KMRVXWVIQV', 'YzY1MjZkOGM0MjZiZDA0OWFkY2YxYTA1YzQ1YmUyZmNiYjcxNmY1MDY2MTFjMzgyMzQ0MWY3YTJkMmRjNTFjM3Jlc3RyaWN0SW5kaWNlcz1jZG5fcGlsb3RfdjEqJm51bWVyaWNGaWx0ZXJzPSU1QiU1QiUyMnZpc2liaWxpdHklM0UyMDAlMjIlNUQlNUQ=');
const $e73bf42412feb220$var$indexName = 'cdn_pilot_v1';
const $e73bf42412feb220$var$widgetsForAttributes = {
    'meta.productcategory': 'menu',
    'meta.productfamily': 'menu',
    'meta.publicationtype': 'refinementList',
    'format': 'menu',
    'lang': 'menu'
};
let $e73bf42412feb220$var$url = window.location.href.split('?')[0];
let $e73bf42412feb220$var$params = new URLSearchParams(window.location.search);
if (!$e73bf42412feb220$var$params.has('format')) $e73bf42412feb220$var$params.set('format', 'web');
if (!$e73bf42412feb220$var$params.has('lang')) $e73bf42412feb220$var$params.set('lang', 'en-GB');
window.history.replaceState(history.state, "", $e73bf42412feb220$var$url + "?" + $e73bf42412feb220$var$params.toString());
const $e73bf42412feb220$var$search = $e73bf42412feb220$var$instantsearch({
    searchClient: $e73bf42412feb220$var$searchClient,
    indexName: $e73bf42412feb220$var$indexName,
    routing: {
        stateMapping: {
            stateToRoute (uiState) {
                const state = uiState[$e73bf42412feb220$var$indexName];
                const route = {
                    query: state.query,
                    page: state.page
                };
                [
                    'refinementList',
                    'hierarchicalMenu',
                    'menuSelect',
                    'menu'
                ].forEach((widget)=>{
                    if (state[widget]) for(var attribute in state[widget])route[attribute] = state[widget][attribute];
                });
                return route;
            },
            routeToState (routeState) {
                const state = {
                    [$e73bf42412feb220$var$indexName]: {
                        refinementList: {},
                        hierarchicalMenu: {},
                        menuSelect: {},
                        menu: {}
                    }
                };
                for(const key in routeState){
                    if (key in $e73bf42412feb220$var$widgetsForAttributes) {
                        const widget = $e73bf42412feb220$var$widgetsForAttributes[key];
                        state[$e73bf42412feb220$var$indexName][widget][key] = routeState[key];
                        continue;
                    }
                    [
                        'query',
                        'page'
                    ].forEach((attribute)=>{
                        if (key === attribute) state[$e73bf42412feb220$var$indexName][attribute] = routeState[key];
                    });
                }
                return state;
            }
        }
    }
});
function $e73bf42412feb220$var$get(fallback, obj, level, ...rest) {
    if (obj === undefined || obj === null) return fallback;
    if (rest.length === 0 && obj.hasOwnProperty(level)) {
        if (obj[level] === null && fallback !== null) return fallback;
        return obj[level];
    }
    return $e73bf42412feb220$var$get(fallback, obj[level], ...rest);
}
function $e73bf42412feb220$var$set(obj, level, ...rest) {
    if (obj === undefined || obj === null) throw Error("Invalid object supplied!");
    if (level === undefined || level === null) throw Error("At least one level must be supplied");
    if (rest.length === 0) throw Error("A value must be supplied as the last argument!");
    if (rest.length === 1) obj[level] = rest[0];
    else $e73bf42412feb220$var$set(obj[level], ...rest);
}
function $e73bf42412feb220$var$transformItems(attributes, items) {
    if (attributes) {
        if (!Array.isArray(attributes)) attributes = [
            attributes
        ];
        // a specific attribute (facet)
        return items.map((item)=>{
            for (const attribute of attributes){
                if (attribute in transformations && item.label in transformations[attribute]) return {
                    ...item,
                    label: transformations[attribute][item.label],
                    highlighted: transformations[attribute][item.label]
                };
            }
            return item;
        });
    } else // search results
    return items.map((item)=>{
        let result = Object.assign({}, item);
        for(let attribute in item)if (attribute in transformations && item[attribute] in transformations[attribute]) result = {
            ...result,
            [attribute]: transformations[attribute][item[attribute]]
        };
        else Object.keys(transformations).forEach((attribute)=>{
            let fields = attribute.split('.');
            if (fields.length > 0) {
                let value = $e73bf42412feb220$var$get(null, item, ...fields);
                if (value != null && value in transformations[attribute]) $e73bf42412feb220$var$set(result, ...fields, transformations[attribute][value]);
            }
        });
        return result;
    });
}
// Modularize card content based on eservices or instruction
function $e73bf42412feb220$var$getCardTemplate(hit) {
    console.log(hit);
    return `
      <article class="card">
  ${$e73bf42412feb220$var$getCardHeader(hit)}
  <div class="card-body">
    <p class="card-text">
    <b>${hit.meta.model}</b>
    <br>
     ${$e73bf42412feb220$var$getCardBody(hit)}
    </div>
  ${$e73bf42412feb220$var$getCardFooter(hit)}    
  </article>`;
}
function $e73bf42412feb220$var$getCardBody(hit) {
    if (hit.meta.publicationtype === 'E-Services Instructions') return `
      PartNo: ${hit.meta.softwarepartnumber || 'N/A'}<br>
      Version: ${hit.meta.softwareversion}`;
    else {
        const variantText = Array.isArray(hit.meta.variant) ? hit.meta.variant.join(' | ') : hit.meta.variant || ' ';
        return `
      ${variantText || ''}<br>
      Serial No: ${hit.meta.serialno || 'N/A'}`;
    }
}
function $e73bf42412feb220$var$getCardHeader(hit) {
    return `<div class="card-header">
  <a class="link-primary text-decoration-none" href="${hit.url}">
  <h5 class="card-title">${hit.meta.publicationtype} | ${hit.meta.productfamily}</h5></a>
  </div>`;
}
function $e73bf42412feb220$var$getCardFooter(hit) {
    return `
  <div class="card-footer">
  <div class="row justify-content-end">
    <div class="col">
      <a class="link-primary text-decoration-none" href="${hit.url}">
      <span class="text-uppercase">${hit.docno}</span> [${hit.versionrelease}] 
      </a>
    </div>
    <div class="col-auto">
      <language-picker
        size="sm"
        lazy="true"
        class="navbar-language-picker"
        variant="lp"
        menuVariant="lp"
        docno="${hit.docno}"
        default="${hit.lang}"
        version="${hit.version}"
        urlprefix=""
        algoliaAppId="KMRVXWVIQV"
        algoliaApiKey="YzY1MjZkOGM0MjZiZDA0OWFkY2YxYTA1YzQ1YmUyZmNiYjcxNmY1MDY2MTFjMzgyMzQ0MWY3YTJkMmRjNTFjM3Jlc3RyaWN0SW5kaWNlcz1jZG5fcGlsb3RfdjEqJm51bWVyaWNGaWx0ZXJzPSU1QiU1QiUyMnZpc2liaWxpdHklM0UyMDAlMjIlNUQlNUQ="
        algoliaIndexName="cdn_pilot_v1"
      ></language-picker>
    </div>
    </div>
</div>`;
}
$e73bf42412feb220$var$search.addWidgets([
    $e73bf42412feb220$var$instantsearch.widgets.searchBox({
        container: '#searchbox'
    }),
    $e73bf42412feb220$var$instantsearch.widgets.hits({
        container: '#hits',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, null),
        templates: {
            item: (hit)=>{
                // Continue to return the template for the item
                return $e73bf42412feb220$var$getCardTemplate(hit);
            }
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menu({
        container: '#meta-productgroup-menu',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.productcategory'),
        attribute: 'meta.productcategory',
        cssClasses: {
            link: 'link-primary'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menu({
        container: '#meta-productfamily-menu',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.productfamily'),
        attribute: 'meta.productfamily',
        limit: 20,
        cssClasses: {
            link: 'link-primary'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.refinementList({
        container: '#meta-type-list',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.publicationtype'),
        attribute: 'meta.publicationtype'
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menuSelect({
        container: '#format-select',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'format'),
        attribute: 'format',
        templates: {
            defaultOption: 'Any'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menuSelect({
        container: '#lang-select',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'lang'),
        attribute: 'lang',
        templates: {
            defaultOption: 'Any'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.pagination({
        container: '#pagination'
    }),
    $e73bf42412feb220$var$instantsearch.widgets.configure({})
]);
$e73bf42412feb220$var$search.start();


//# sourceMappingURL=se.simonsoft.vab.pilot.0b20ed6a.js.map
